import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Rl1 } from '@app/models/payroll/rl1.model';
import { ReturnShowView } from '../../return-show.view';

@Component({
    templateUrl: './rl-1-show.template.html',
})
export class Rl1ShowView extends ReturnShowView {
    get rl1(): Rl1 {
        return this.form as Rl1;
    }

    constructor(route: ActivatedRoute) {
        super(route, 'rl1');
        this.isLoading = false;
    }
}
